import { Table, TableCell, TableHead, TableRow } from '@material-ui/core';
import { ClassAttributes, createElement } from 'react';
import { FormattedMessage } from 'react-intl';

import {
  CreativeFormat,
  CreativeFormatAspectRatio,
  CreativeFormatFastStart,
  CreativeFormatPlaybackTime,
  File,
} from '../../../../graphql/generated/graphql';
import CreativeAttributeTableRows from './CreativeAttributeTableRows';

interface Props {
  file?: Pick<File, 'fastStart' | 'attribute'> | null;
  creativeFormat: {
    creativeType: Pick<CreativeFormat['creativeType'], 'key' | 'name'>;
    attribute: {
      playbackTime?: {
        seconds: CreativeFormatPlaybackTime['seconds'];
      } | null;
      aspectRatio?: Pick<CreativeFormatAspectRatio, 'aspectRatio' | 'size'> | null;
      fastStart?: CreativeFormatFastStart | null;
    };
  };
  className?: string;
}

const CreativeAttributeTable = ({ file, creativeFormat, className }: ClassAttributes<HTMLElement> & Props) => {
  const uploadedFile = file ? file : null;

  return (
    <Table className={className}>
      <TableHead>
        <TableRow>
          <TableCell>
            <FormattedMessage id="show_creation_page.submission.attribute_table.attribute" />
          </TableCell>
          <TableCell>
            <FormattedMessage id="show_creation_page.submission.attribute_table.creative_brief" />
          </TableCell>
          <TableCell>
            <FormattedMessage id="show_creation_page.submission.attribute_table.creative" />
          </TableCell>
        </TableRow>
      </TableHead>
      <CreativeAttributeTableRows file={uploadedFile} creativeFormat={creativeFormat} />
    </Table>
  );
};

export default CreativeAttributeTable;
